import { LoadFranchise } from "../../domain/usecase/load-franchise"
import { FranchiseModel } from "../entity/franchise-model"
import { HttpGetClient } from "../http-client/http-get-client"

export class RemoteLoadFranchise implements LoadFranchise {
  private readonly apiUrl: string
  private readonly httpClient: HttpGetClient<any, FranchiseModel>

  constructor (apiUrl: string, httpClient: HttpGetClient<any, FranchiseModel>) {
    this.apiUrl = apiUrl
    this.httpClient = httpClient
  }

  async handle (): Promise<LoadFranchise.Result> {
    return await this.httpClient.get({ url: `${this.apiUrl}/page` })
  }
}